import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// antd
import { FileDoneOutlined } from '@ant-design/icons';
import { Modal, Button } from 'antd';
// components
import AplGrid from 'common/components/apl-grid/AplGrid';
// hooks
import { useFilterGrid } from 'hooks/useFilterGrid';
// redux
import * as actionsGridView from 'common/components/grid-view/controllers/actions';

const FilterMyAplsModal = (props) => {
  const { visible, setVisible, entityType = 'product' } = props;
  const dispatch = useDispatch();

  const [selectedRows, setSelectedRows] = useState([]);

  const { gridFilters, updateGridFilter } = useFilterGrid({
    entityType: entityType,
  });

  const onSelectApl = (selectedAplItem) => {
    setSelectedRows(selectedAplItem);
  };

  const handleApplyApl = () => {
    dispatch(actionsGridView.resetPageCurrent());

    let newFilterProducts = [...gridFilters];
    newFilterProducts = newFilterProducts.filter(
      (val) => val?.filter !== 'apl'
    );

    newFilterProducts.push({
      filter: 'apl',
      value: selectedRows[0],
    });
    updateGridFilter(newFilterProducts);
    setVisible(false);
  };

  return (
    <Modal
      title='Filter My APLs'
      visible={visible}
      onCancel={() => {
        setVisible(false);
      }}
      width='80vw'
      height='80vh'
      footer={
        <Button
          type='primary'
          icon={<FileDoneOutlined />}
          disabled={selectedRows?.length === 0}
          onClick={handleApplyApl}
        >
          Apply
        </Button>
      }
    >
      <div style={{ height: '70vh' }}>
        <AplGrid onSelectRow={onSelectApl} />
      </div>
    </Modal>
  );
};

export default FilterMyAplsModal;
